import { OtpRequiredResponse, RecoverPasswordPayload } from '@repo/user-types'
import { AxiosInstance, AxiosResponse } from 'axios'

export const recoverPassword = async ({
  api,
  params,
}: {
  api: AxiosInstance
  params: RecoverPasswordPayload
}): Promise<AxiosResponse<OtpRequiredResponse>> => {
  return api.post<OtpRequiredResponse>('/user/recover-password', params)
}
